import { array, literal, struct, tuple, union } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import { Id as ClientId } from '../../client/Id';
import { Id as CustomerId } from '../../customer/Id';
import { Id as JobTypeId } from '../../job/job-type';
import { Id as requestTypeId } from '../../job/request-type';
import { Id as RequirementId } from '../../report/RequirementsWithUnknown';
import { DifficultyWithUnknown } from '../DifficultyWithUnknown';

export const FilterRequest = struct({
	client: array(ClientId),
	customer: array(union(literal('customer:unknown'), CustomerId)),
	jobType: array(JobTypeId),
	requestType: array(requestTypeId),
	requirements: array(array(RequirementId)),
	difficulty: array(DifficultyWithUnknown),
	completedAt: tuple(iotsUtils.ValidDate, iotsUtils.ValidDate),
});
